import {createSlice} from '@reduxjs/toolkit';
import Api from "../utils/api_calls";

const initialState = {
    attributes: [],
}

const attributesSlice = createSlice({
    name: 'attributes',
    initialState,
    reducers: {
        updateAttributes: (state, {payload}) => {
            state.attributes = payload;
        }
    }
})
export const {updateAttributes} = attributesSlice.actions;
export const attributesSelector = state => state.attributes;
export default attributesSlice.reducer

export const getAttributes = () => dispatch => {
    return Api.getCategories(response => {
        console.log("response", response);
        dispatch(updateAttributes(response.data))
    })
}